module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921072651_T.53a09ed4.jpg";